
<!--<div class="kt-section">
	<div class="kt-section__content">
		<div class="modal-header">
			<h4 class="modal-title">
				Yetersiz Stok Ürün Listesi
			</h4>
			<button type="button" class="close" aria-label="Close" (click)="close()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<kt-custom-description [description]="desc">
			</kt-custom-description>
			<div class="row sktLot-2">
				<div class="col-md-7">
					<div class="form-group row">
						<div class="col-lg-12 kt-margin-b-10-tablet-and-mobile">
							
									<table class="table table-striped responsive" wt-responsive-table>
										<thead>
											<tr>
												<th width="140">Ürün Numarası</th>
												<th width="120">SKT</th>
												<th width="140">LOT</th>
												<th width="140">Barcode</th>
											</tr>
										</thead>
									</table>
									<table class="table table-striped responsive vrt-table" wt-responsive-table>
										<tbody>
											<tr *ngFor="let product of (products | async)">
												<td width="120">
													{{product.productId ? product.productId : '-'}}
												</td>

												<td width="120">
													{{product.exprirationDate  ? product.exprirationDate : '-'}}
												</td>

												<td width="120">
													{{product.lot  ? product.lot : '-'}}
												</td>

												<td width="120">
													{{product.barcode  ? product.barcode : '-'}}
												</td>




											</tr>
										</tbody>
									</table>
						</div>
					</div>
				</div>
				
				
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="close()">Kapat</button>
		</div>
	</div>
</div>-->


<div class="kt-section">
	<div class="kt-section__content">
		<!--<ng-template #content6 let-c="close" let-d="dismiss">-->
			<div class="modal-header">
				<h4 class="modal-title">
					{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TITLE' | localize }}
				</h4>
				<button type="button" class="close" aria-label="Close" (click)="close()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="alert alert-danger" role="alert">
					<div class="alert-icon"><i class="flaticon-warning"></i></div>
					<div class="alert-text">

						{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.SUBTITLE' | localize }}
					</div>
				</div>
				<table class="table table-striped responsive" wt-responsive-table>
					<thead>
						<tr>
							<th>#</th>
							<th>{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TABLE.TH.PRODUCTCODE' | localize }}</th>
							<th>{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TABLE.TH.PRODUCTNAME' | localize }}</th>
							<th>{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TABLE.TH.EXPIRATIONDATE' | localize }}</th>
							<th>{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TABLE.TH.LOT' | localize }}</th>
							<th>{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.TABLE.TH.BARCODE' | localize }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let product of (products | async); index as i">
							<td>
								{{i+1}}
							</td>
							<td>
								{{product.productCode ? product.productCode : '-'}}
							</td>
							<td>
								{{product.productName ? product.productName : '-'}}
							</td>
							<td>
								{{product.exprirationDate  ? product.exprirationDate : '-'}}
							</td>
							<td>
								{{product.lot  ? product.lot : '-'}}
							</td>
							<td>
								{{product.barcode  ? product.barcode : '-'}}
							</td>
						</tr>
						
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="close()">
					
					{{ 'FE.PRODUCTGRID.OVERSTOCKMODAL.BUTTON.CLOSE' | localize }}

				</button>
			</div>
		<!--</ng-template>-->
	</div>
</div>
